<template>
  <div class="loginregister">
    <div class="contain">
      <div class="capture register-block">
        <div class="contain">
          <div class="text">
            <h2>Let's Get Started.</h2>
            <p>
              Fill out the form and we’ll get back to you with details and next
              steps.
            </p>
          </div>
          <div class="form">
            <form v-on:submit.prevent="onSubmit">
              <div class="inputs">
                <div class="input">
                  <label>First Name <span class="required">*</span></label>
                  <input
                    type="text"
                    placeholder="Type here"
                    v-model="user.first_name"
                  />
                </div>
                <div class="input">
                  <label>Last Name <span class="required">*</span></label>
                  <input type="text" v-model="user.last_name" />
                </div>
                <div class="input">
                  <label>Email Address <span class="required">*</span></label>
                  <input type="email" v-model="user.email" />
                </div>
                <div class="input">
                  <label>Phone Number <span class="required">*</span></label>
                  <vue-tel-input v-model="user.phone"></vue-tel-input>
                </div>
                <div class="input full">
                  <label>Company <span class="required">*</span></label>
                  <input type="text" v-model="user.company" />
                </div>
                <div class="input">
                  <label>Password <span class="required">*</span></label>
                  <input type="password" v-model="password" />
                </div>
                <div class="input">
                  <label
                    >Confirm Password <span class="required">*</span></label
                  >
                  <input type="password" v-model="confirm_password" />
                </div>
                <div class="btns right">
                  <transition name="fade-quick">
                    <div>
                      <button
                        @click="validate()"
                        v-if="status == 'submit'"
                        class="btn"
                      >
                        Start Creating Surveys
                      </button>
                      <transition name="fade-quick">
                        <p class="error">{{ feedback }}</p>
                      </transition>
                    </div>
                  </transition>
                  <transition name="fade-quick">
                    <img
                      class="loader"
                      v-if="status == 'loading'"
                      src="@/assets/img/loader.gif"
                    />
                  </transition>
                  <transition name="fade-quick">
                    <div class="success" v-if="status == 'success'">
                      <p>
                        You've been Registered!
                        <span
                          >We are redirecting you to your dashboard now...</span
                        >
                      </p>
                    </div>
                  </transition>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <login></login>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Login from "@/components/Login";
import axios from "axios";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;
const auth = fb.default.auth;

export default {
  name: "loginregister",
  components: {
    login: Login,
  },
  data() {
    return {
      login: {
        email: null,
        password: null,
      },
      password: null,
      confirm_password: null,
      user: {
        first_name: null,
        last_name: null,
        name: null,
        email: null,
        slug: null,
        phone: null,
        company: null,
        email_digest: { option: "Daily", on: true, additional_users: [] },
        plan_id: null,
      },
      status: "submit",
      feedback: null,
      sendEmail: functions.httpsCallable("sendEmail"),
      registerUser: functions.httpsCallable("registerUser"),
    };
  },
  mounted() {},
  created() {},
  updated() {},
  methods: {
    onSubmit(e) {
      e.preventDefault();
    },
    async validate() {
      this.user.slug = this.user.company
        .split(" ")
        .join("_")
        .toLowerCase();
      let valid = true;
      let user = this.user;
      for (let key in user) {
        if (key != "name" && key != "plan_id" && !user[key]) valid = false;
      }

      const isDuplicateName = await this.checkDuplicateName();
      if (valid) {
        if (this.confirm_password != this.password) {
          this.feedback = "Password do not match!";
          return;
        } else if (isDuplicateName) {
          this.feedback = "This company has already been taken!";
        } else {
          this.save();
        }
      } else {
        this.feedback = "Please enter all required fields";
      }
    },
    async checkDuplicateName() {
      const existingDocs = await db
        .collection("user")
        .where("slug", "==", this.user.slug)
        .get()
        .then((snapshot) => {
          return snapshot.docs.length;
        });
      return existingDocs;
    },
    async save() {
      this.changeStatus("loading");
      this.user.name = this.user.first_name + " " + this.user.last_name;
      const createCustomer = functions.httpsCallable("stripe-createCustomer");
      return this.registerUser({ user: this.user, password: this.password })
        .then((result) => {
          return createCustomer({
            customer: {
              email: this.user.email,
              phone: this.user.phone,
              name: this.user.name,
            },
            uid: result.data,
          });
        })
        .then((result) => {
          return auth.signInWithEmailAndPassword(
            this.user.email,
            this.password
          );
        })
        .then((user) => {
          return this.sendVerficationEmails();
        })
        .then(() => {
          return setTimeout(() => {
            this.status = "success";
            this.feedback = null;
            setTimeout(() => {
              this.goTo("/dashboard");
            }, 3000);
          }, 500);
        })
        .catch((err) => {
          return this.handleRegError(err);
        });
    },
    handleRegError(err) {
      this.changeStatus("submit");
      this.feedback = err.message;
    },
    async sendVerficationEmails() {
      return await Promise.all([
        this.sendEmail({
          template_name: "covid-19-survey-register",
          from_email: null,
          to_email: [
            {
              email: this.user.email,
              type: "to",
            },
          ],
          global_merge_vars: [
            {
              name: "name",
              content: this.user.name,
            },
          ],
          message: null,
        }),
        this.sendEmail({
          template_name: "covid19-new-registration",
          from_email: null,
          to_email: [
            {
              email: "eitan@popshap.com",
              type: "to",
            },
            {
              email: "modi@popshap.com",
              type: "to",
            },
          ],
          global_merge_vars: [
            {
              name: "name",
              content: this.user.name,
            },
          ],
          message: null,
        }),
      ]);
    },
    changeStatus(status) {
      this.status = null;
      setTimeout(() => {
        this.status = status;
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
.loginregister {
  padding-top: 50px;
  background: white;
  .contain {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;
    .form {
      margin-top: 30px;
      @media screen and (max-width: 800px) {
        margin-top: -20px;
      }
    }
  }
}
.capture {
  width: 50%;
  @media screen and (max-width: 800px) {
    width: 100%;
  }
  &.register-block {
    padding-right: 50px;
    border-right: 2px solid #eaeaea;
    @media screen and (max-width: 900px) {
      padding-bottom: 50px;
      padding-right: 0;
      border-right: none;
    }
  }
  &.login-block {
    padding-left: 10px;
    border-left: none;
    @media screen and (max-width: 900px) {
      padding-left: 0;
    }
  }
  .contain {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0 !important;
    min-height: auto;
    @media screen and (max-width: 800px) {
      flex-direction: column;
    }
    & > div {
      width: 100%;
      @media screen and (max-width: 800px) {
        width: 100%;
      }
    }
    .inputs {
      @media screen and (max-width: 800px) {
        width: 100%;
        margin-top: 50px;
      }
      .input {
        // @media screen and (max-width: 800px){
        //   width: 100%;
        // }
      }
      .btns {
        display: flex;
        justify-content: flex-end;
        width: 100%;
        .loader {
          height: 50px;
          filter: brightness(0.96);
        }
        .success {
          font-size: 25px;
          color: #00bf6f;
          font-weight: bold;
          span {
            display: block;
            color: #132628;
            font-size: 16px;
            font-weight: 400;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

.home .contain {
  min-height: auto;
}

.home .loginregister {
  padding-top: 50px !important;
  min-height: auto;
}
</style>
